import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Ctx = createContext();
export const useApp = () => useContext(Ctx);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState(() => JSON.parse(localStorage.getItem("lcw_cart") || "[]"));
  const [content, setContent] = useState({});

  const token = () => localStorage.getItem("lcw_token");
  const authHeaders = () => token() ? { Authorization: `Bearer ${token()}` } : {};

  const refreshContent = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/content`);
      setContent(r.data);
    } catch (err) {
      if (err?.response?.status !== 404) console.error("Content fetch failed:", err);
    }
  }, []);

  useEffect(() => { refreshContent(); }, [refreshContent]);

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    const t = localStorage.getItem("lcw_token");
    const headers = t ? { Authorization: `Bearer ${t}` } : {};
    try {
      const r = await axios.get(`${API}/auth/me`, { headers });
      setUser(r.data);
    } catch (err) {
      if (err?.response?.status !== 401) console.error("Auth check failed:", err);
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  useEffect(() => { localStorage.setItem("lcw_cart", JSON.stringify(cart)); }, [cart]);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("lcw_token", r.data.token);
    setUser(r.data.user); return r.data.user;
  };
  const signup = async (email, password, name) => {
    const r = await axios.post(`${API}/auth/signup`, { email, password, name });
    localStorage.setItem("lcw_token", r.data.token);
    setUser(r.data.user); return r.data.user;
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`, {}, { headers: authHeaders() }); }
    catch (err) { console.error("Logout failed:", err); }
    localStorage.removeItem("lcw_token"); setUser(null);
  };

  const addToCart = (product, qty=1) => {
    setCart(c => {
      const i = c.findIndex(x => x.product_id === product.product_id);
      if (i >= 0) { const n = [...c]; n[i].qty += qty; return n; }
      return [...c, { product_id: product.product_id, name: product.name, price: product.price, qty, image: product.images?.[0] }];
    });
  };
  const removeFromCart = (pid) => setCart(c => c.filter(x => x.product_id !== pid));
  const updateQty = (pid, qty) => setCart(c => c.map(x => x.product_id === pid ? {...x, qty: Math.max(1, qty)} : x));
  const clearCart = () => setCart([]);

  const ctxValue = useMemo(() => ({
    user, setUser, loading, cart, addToCart, removeFromCart, updateQty, clearCart,
    login, signup, logout, API, authHeaders, checkAuth,
    content, refreshContent
  }), [user, loading, cart, checkAuth, content, refreshContent]);

  return <Ctx.Provider value={ctxValue}>{children}</Ctx.Provider>;
}
